import { Grid, useMediaQuery } from '@material-ui/core'
import { createStyles, makeStyles, useTheme } from '@material-ui/core/styles'
import Alert from '@material-ui/lab/Alert'
import React, { useMemo, useState } from 'react'
import { useMeasure } from 'react-use'
import {
  extendPublicStream,
  PublicStreamExtended,
} from '../../api/StreamExtended'
import { usePublicProject } from '../PublicProjectWrapper'
import { VideoPlayerPublicHLS } from './VideoPlayerPublicHLS'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      minHeight: `calc(100vh - ${theme.custom.projectNavHeight}px)`,
      width: '100%',
      '& video': {
        display: 'block',
      },
    },
    alert: {
      borderRadius: 0,
      border: '1px solid #000',
      borderTopWidth: 0,
      fontWeight: 'bold',
      boxSizing: 'border-box',
    },
    videoContainer: {
      border: '1px solid #000',
      display: 'flex',
      flexDirection: 'column',
    },
    player: {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  })
)

export const LiveVideosPageDesktopPublic = () => {
  const theme = useTheme()
  const classes = useStyles()
  const project = usePublicProject()

  const [gridContainerRef, containerDims] = useMeasure<HTMLDivElement>()

  const twoColumn = useMediaQuery(theme.breakpoints.up('lg'))
  const [modalStreamID, setModalStreamID] = useState<number>()

  const streams: PublicStreamExtended[] = useMemo(() => {
    return project.streams
      .filter((s) => s.url && s.live === true)
      .map((s) => extendPublicStream(s, project))
  }, [project])

  for (let i = 0; i < streams.length; i += 2) {
    if (!streams[i + 1]) {
      // if it's the last stream and a widow, make it full width
      streams[i].width = 1
      break
    }
    if (streams[i].full_width === true) {
      // if it's full length, we only increment +1 on the next loop iteration
      // do this by decrementing one here and incrementing two in the loop definition
      streams[i].width = 1
      i--
      continue
    }
    const leftVidAspect = streams[i].rotatedAspectRatioNumber
    const rightVidAspect = streams[i + 1].rotatedAspectRatioNumber
    streams[i].width = twoColumn
      ? leftVidAspect / (leftVidAspect + rightVidAspect)
      : 1
    streams[i + 1].width = twoColumn
      ? rightVidAspect / (leftVidAspect + rightVidAspect)
      : 1
  }

  return (
    <div className={classes.root}>
      {project && project.live === false ? (
        <Alert severity="warning" className={classes.alert}>
          Live streams not available at the moment.
        </Alert>
      ) : (
        <>
          <Grid container ref={gridContainerRef}>
            {streams.map((stream) => (
              <Grid
                item
                key={stream.url}
                style={{ width: stream.width * 100 + '%' }}
                className={classes.videoContainer}
              >
                <VideoPlayerPublicHLS
                  stream={stream}
                  className={classes.player}
                  parentWidth={containerDims.width}
                  reserveNavSpace={true}
                />
              </Grid>
            ))}
          </Grid>
        </>
      )}
    </div>
  )
}
